module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('california-map', {
    attrs: {
      "mapFile": "ca.counties.json",
      "dataFile": "ca_load.csv",
      "res": "Shasta Dam",
      "resFile": "ca.json",
      "whichState": "CA"
    }
  }), _vm._v(" "), _c('snow-chart', {
    attrs: {
      "whichState": "CA"
    }
  }), _vm._v(" "), _c('drought-map', {
    attrs: {
      "mapFile": "ca.counties.json",
      "centersFile": "ca_centers.json",
      "dataFile": "ca-counties.csv"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-721e1d75"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/California.vue
// module id = 379
// module chunks = 1